import r from"./_arrayPush.js";import a from"./isArray.js";var o=r,t=a;var s=function(r,a,s){var f=a(r);return t(r)?f:o(f,s(r))};export{s as default};
//# sourceMappingURL=_baseGetAllKeys.js.map
